@if (isLoaded){
    @if (eventID && eventID > 0){
<h1 mat-dialog-title>EDIT EVENT</h1>

    }@else {
<h1 mat-dialog-title>ADD NEW EVENT</h1>

    }

<mat-dialog-content class="pt-3">
<form [formGroup]="eventForm" class="therapist__form">

    <div class="col-12 mb-3">
        <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>EVENT NAME</mat-label>
            <input type="text" matInput formControlName="eventName" placeholder="Coventry 2025">
            @if (eventForm.get('eventName')?.hasError('required')) {
            <mat-error>Event name is <strong>required</strong></mat-error>
            }
        </mat-form-field>
    </div>


    <div class="col-12 mb-3">
        <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>VENUE</mat-label>
            <input type="text" matInput formControlName="venueName" placeholder="Coventry Arena">
            @if (eventForm.get('venueName')?.hasError('required')) {
            <mat-error>Venue name is <strong>required</strong></mat-error>
            }
        </mat-form-field>
    </div>

    <div class="col-12 mb-3">
        <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>ADDRESS</mat-label>
            <input type="text" matInput formControlName="address" placeholder="1 High Street">
        </mat-form-field>
    </div>
<div class="row">
    <div class="col-6 mb-3">
        <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>CITY</mat-label>
            <input type="text" matInput formControlName="city" placeholder="Coventry">
        </mat-form-field>
    </div>

    <div class="col-6 mb-3">
        <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>COUNTRY</mat-label>
            <input type="text" matInput formControlName="country" placeholder="United Kingdom">
        </mat-form-field>
    </div>
</div>

<div class="row">
    <div class="col-6 mb-3">
        <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>START DATE</mat-label>
            <input matInput [matDatepicker]="picker" formControlName="startDate" placeholder="DD/MM/YYYY">
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>

    </div>

    <div class="col-6 mb-3">
        <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">
            <mat-label>END DATE</mat-label>
            <input matInput [matDatepicker]="endPicker" formControlName="endDate" placeholder="DD/MM/YYYY">
            <mat-datepicker-toggle matSuffix [for]="endPicker"></mat-datepicker-toggle>
            <mat-datepicker #endPicker></mat-datepicker>
        </mat-form-field>

    </div>
</div>

<div class="row">
    <div class="col-6 mb-3">

 <mat-form-field class="w-100" appearance="outline" hideRequiredMarker="true">  
        <mat-label>STATUS</mat-label>
  
<mat-select formControlName="eventStatusID">
    @for (status of eventStatuses; track status.eventStatusID){
    <mat-option [value]="status.eventStatusID">
        {{status.statusName}}
    </mat-option>
    }

</mat-select>
</mat-form-field>   

    </div>

        <div class="col-6 mb-3">
          <mat-slide-toggle formControlName="active">ACTIVE</mat-slide-toggle>

        </div>
</div>


    <div class="row">
        <div class="col-6">
 <button mat-dialog-close class="w-100" mat-button color="accent">
        CANCEL
    </button>
        </div>
        <div class="col-6">
    @if (eventID){
    <button (click)="updateEvent();" class="w-100" mat-flat-button color="primary">
        UPDATE
        EVENT
    </button>
    }
    @else {
    <button (click)="addEvent();" class="w-100" mat-flat-button color="primary">
        CREATE
        EVENT
    </button>
    }
        </div>
    </div>



</form>
</mat-dialog-content>
}